import styled from "styled-components";

const Team = ()=> {
    return(
        <Container>
            <Content>
                <Caption>
                    <span>Expert People</span>
                    <h2>Global leadership team</h2>
                    <p>Talent wins games, but teamwork and intelligence win championships.</p>
                </Caption>
                <Gallery>
                    <div className="gallery__team">
                        <img src ="/images/team/winner.jpeg" alt =""/>
                        <Name>Winner Akogwu</Name>
                        <Title>Chief Executive Officer</Title>
                    </div>
                    <div className="gallery__team">
                        <img src ="/images/team/lawyer.jpeg" alt =""/>
                        <Name>Barr. Agbali Peter</Name>
                        <Title>Legal Advisor</Title>
                    </div>
                    <div className="gallery__team">
                        <img src ="/images/team/ayo.jfif" alt =""/>
                        <Name>Ayo Moses</Name>
                        <Title>Chief Technology Officer</Title>
                    </div>
                    <div className="gallery__team">
                        <img src ="/images/team/partner.jpeg" alt =""/>
                        <Name>Alobo Victor</Name>
                        <Title>Partner</Title>
                    </div>
                </Gallery>
            </Content>
        </Container>
    )
} 

const Container = styled.div`
    padding: 50px 20px;

    @media(min-width: 768px){
        padding: 50px;
    }

    @media(min-width: 960px){
        padding: 20px;
    }

    font-size: 15px;
`
const Content = styled.div``

const Caption = styled.div`
    text-align: center;

    span{
        color: rgb(231, 60, 62);
    }
`
const Gallery = styled.div`
    display: flex;
    flex-direction: column;

    @media(min-width: 500px){
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
    }
    
    img{
        width: 100%;
        height: 300px;
        object-fit: contain;
    
        @media(min-width: 501px){
            height: 400px;
            object-fit: contain;
            width: 100%;
        }
        @media(max-width: 500px){
            height: 400px;
            object-fit: cover;
            width: 100%;
        }
    }
    

    div.gallery__team{
        margin-bottom: 20px;

        @media(max-width: 490px){
            width: 100%;
        }
        @media(min-width: 490px){
            width: 100%;
        }
        @media(min-width: 960px){
            width: 24%;
        }
    }
`

const Name = styled.div`
    font-size: 20px;
    font-weight: 500;
    font-family: 'Rubik', sans-serif;
    color: rgb(231, 60, 62);

    @media( min-width: 492px){
        text-align: center;
    }
`

const Title = styled.div`
    @media( min-width: 492px){
        text-align: center;
    }
`
export default Team
